import { TFunction } from 'i18next';

import { defaultTheme } from '@/styles/theme';

type WarningConfig = {
  color: string;
  tooltip: string;
} | null;

export const getProblemReportWarningConfig = (
  daysSinceLastReport: number,
  t: TFunction<['DefaultTranslations' | 'ProblemReportsTranslations']>
): WarningConfig => {
  if (daysSinceLastReport >= 30) {
    return {
      color: defaultTheme.colors.red6,
      tooltip: t('ProblemReportsTranslations:WARNING_30_DAYS')
    };
  }

  if (daysSinceLastReport >= 14) {
    return {
      color: defaultTheme.colors.orange6,
      tooltip: t('ProblemReportsTranslations:WARNING_14_DAYS')
    };
  }

  return null;
};
